 @if (menuAbierto()) {
  <div class="overlay-movil" (click)="cerrarMenu()"></div>
}

<button class="btn-colapso-flotante" (click)="toggleColapso()">
    <mat-icon>{{ menuColapsado() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </button>
<button class="btn-modo-oscuro-flotante" type="button" (click)="toggleModoOscuro()" [matTooltip]="modoOscuro() ? 'Modo claro' : 'Modo oscuro'">
    <mat-icon>{{ modoOscuro() ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>

<nav class="menu-lateral"
      [class.abierto-movil]="menuAbierto()"
     [class.colapsado]="menuColapsado()"
>
 <div class="logo-contenedor">
    <img [src]="logoAMostrar()" alt="Logo Principal" class="liga-logo">
    
    @if (!menuColapsado() && (rolActivoSignal()?.escudoURL || liga?.appIcon)) {
      <img src="assets/images/TT-Logo-Americano.svg" class="logomini" />
    }
    
    @if (menuColapsado() && rolActivoSignal()?.escudoURL) {
        <!--img src="assets/images/TT-Logo-Americano.svg" class="logomini-colapsado" /-->
    }
  </div>

 <ul class="lista-opciones">
    @for (opcion of opcionesMenuFiltradas(); track opcion.nombre) { 
      <li>
        @if (menuColapsado() && opcion.hijos) {
          <!-- Comprimida: los submenús salen en un panel flotante a un lado -->
          <a class="nav-link" [class.activo]="tieneHijoActivo(opcion)" [matMenuTriggerFor]="menuFlotante" [matMenuTriggerData]="{ opcion: opcion }"
             [matTooltip]="obtenerNombreOpcion(opcion)" matTooltipPosition="right">
            <mat-icon [svgIcon]="opcion.icono" class="menu-svg-icon"></mat-icon>
          </a>
        } @else {
        <a [routerLink]="opcion.hijos ? null : ['/', routesUrl.MAIN, opcion.ruta]"
           routerLinkActive="activo"
           class="nav-link"
           [queryParamsHandling]="opcion.preserveQueryParams ? 'preserve' : ''"
           [queryParams]="opcion.queryParams ?? null"
           [matTooltip]="obtenerNombreOpcion(opcion)" matTooltipPosition="right" [matTooltipDisabled]="!menuColapsado()"
           (click)="opcion.hijos ? toggleMenu(opcion) : null">
          <mat-icon [svgIcon]="opcion.icono" class="menu-svg-icon"></mat-icon>
          <span class="nombre-opcion" *ngIf="!menuColapsado()">{{ obtenerNombreOpcion(opcion) }}</span>
          
          <span class="flecha" *ngIf="opcion.hijos && !menuColapsado()">{{ opcion.desplegado ? '▲' : '▼' }}</span>
        </a>
        }

        <ul class="lista-hijos" *ngIf="opcion.hijos && opcion.desplegado && !menuColapsado()">
          @for (hijo of opcion.hijos; track hijo.nombre) {
            <li>
              <a [routerLink]="hijo.nietos ? null : '/' + routesUrl.MAIN + '/' + hijo.ruta"
                 routerLinkActive="activo"
                 class="nav-link sub-link"
                 (click)="hijo.nietos && !hijo.ruta ? toggleMenu(hijo) : null">
                @if (!hijo.icono) {<span class="punto-guia">●</span>}
                @if (hijo.icono) {<mat-icon [svgIcon]="hijo.icono" class="menu-svg-icon-hijo"></mat-icon>}
                <span class="nombre-opcion">{{ hijo.nombre }}</span>
                <span class="flecha" *ngIf="hijo.nietos && !menuColapsado()">{{ hijo.desplegado ? '▲' : '▼' }}</span>
              </a>

                <ul class="lista-nietos" *ngIf="hijo.nietos && hijo.desplegado && !menuColapsado()">
                  @for (nieto of hijo.nietos; track nieto.nombre) {
                    <li>
                      <a [routerLink]="'/' + routesUrl.MAIN + '/' + nieto.ruta"
                         routerLinkActive="activo"
                         class="nav-link sub-link"
                         [queryParamsHandling]="nieto.preserveQueryParams ? 'preserve' : ''">
                        @if (!nieto.icono) {<span class="punto-guia">●</span>}
                        @if (nieto.icono) {<mat-icon [svgIcon]="nieto.icono" class="menu-svg-icon-hijo"></mat-icon>}
                        <span class="nombre-opcion">{{ nieto.nombre }}</span>
                      </a>
                    </li>
                  }
                </ul>
            </li>
          }
        </ul>
      </li>
    }
  </ul>

  <!-- Ayuda: centro de ayuda de tawk.to; queda hasta abajo salvo que el menú necesite scroll -->
  @if (ayudaDisponible) {
  <div class="ayuda-contenedor">
    <a class="btn-ayuda" [href]="urlAyuda" target="_blank" rel="noopener noreferrer"
       matTooltip="Ayuda" matTooltipPosition="right" aria-label="Ayuda">
      <mat-icon>help_outline</mat-icon>
    </a>
  </div>
  }
</nav>

<mat-menu #menuFlotante="matMenu" xPosition="after" class="menu-lateral-flotante">
  <ng-template matMenuContent let-opcion="opcion">
    <div class="menu-flotante-titulo">{{ obtenerNombreOpcion(opcion) }}</div>
    @for (hijo of opcion.hijos; track hijo.nombre) {
      @if (hijo.nietos) {
        <button mat-menu-item type="button" [matMenuTriggerFor]="menuNietos" [matMenuTriggerData]="{ hijo: hijo }">
          @if (hijo.icono) {<mat-icon [svgIcon]="hijo.icono"></mat-icon>}
          <span>{{ hijo.nombre }}</span>
        </button>
      } @else {
        <a mat-menu-item [routerLink]="'/' + routesUrl.MAIN + '/' + hijo.ruta" routerLinkActive="activo">
          @if (hijo.icono) {<mat-icon [svgIcon]="hijo.icono"></mat-icon>}
          <span>{{ hijo.nombre }}</span>
        </a>
      }
    }
  </ng-template>
</mat-menu>

<mat-menu #menuNietos="matMenu" class="menu-lateral-flotante">
  <ng-template matMenuContent let-hijo="hijo">
    @for (nieto of hijo.nietos; track nieto.nombre) {
      <a mat-menu-item [routerLink]="'/' + routesUrl.MAIN + '/' + nieto.ruta" routerLinkActive="activo"
         [queryParamsHandling]="nieto.preserveQueryParams ? 'preserve' : ''">
        @if (nieto.icono) {<mat-icon [svgIcon]="nieto.icono"></mat-icon>}
        <span>{{ nieto.nombre }}</span>
      </a>
    }
  </ng-template>
</mat-menu>
